(function (win, $) {
    'use strict';

    // Trigger live chat
    const doc = win.document,
        $win = $(win),
        $doc = $(doc),
        $body = $('body'),
        $grid = $('main .grid').first(),
        $footer = $('#main-footer'),
        statusUrl = $body.data('livechatstatus'),
        cbButtonId = 'chatBeaconBtn';
    let $cbButton, cbButtonOuter, isOnline, showBadge, noBadge,
        $floating = $('.livechat-floating').first(),
        $badge = $('.livechat-badge', $floating),
        $buttons = $('[data-trigger-chat]');

    // Handle positioning of floating Live Chat badge
    function badgePosition() {
        const left = $grid[0].getBoundingClientRect().left,
            padding = parseInt($grid.css('paddingLeft')),
            badgeWidth = $badge.width();

        if ($doc.scrollTop() + win.innerHeight >= $footer.offset().top) {
            (win.innerWidth >= 1200) ? $badge.css({'position': 'absolute', 'right': left - badgeWidth}) : $badge.css({'position': 'absolute', 'right': padding * (2/3) });
        } else {
            (win.innerWidth >= 1200) ? $badge.css({'position': 'fixed', 'right': left - badgeWidth }) : $badge.css({'position': 'fixed', 'right': padding * (2/3) });
        }
    }

    // Update the online state of the buttons
    function updateButtonOnlineState() {
        if (cbButtonOuter) {
            if (isOnline) {
                $body.addClass('livechat-online');
                $buttons.attr({'aria-label': 'Open live chat window', 'title': 'Start a chat with us'});
            } else {
                $buttons.attr({'aria-label': 'Open a window to write us', 'title': 'Write us'});
            }
        } else {
            $buttons.attr({'aria-label': 'Visit the Contact Us page', 'title': 'Write us'});
        }
    }

    // Enable triggering the ChatBeacon handler once it is loaded
    function onChatBeaconLoaded() {
        if (!cbButtonOuter) return;

        updateButtonOnlineState();

        const evt = 'click.livechat';
        $body.addClass('livechat-loaded')
            .off(evt).on(evt, '[data-trigger-chat]', function(e) {
                // Keep looking for the button until it is found
                $cbButton = ($cbButton && $cbButton.length) ? $cbButton : $('>button', cbButtonOuter).first();
                if ($cbButton.length) {
                    e.preventDefault();
                    $cbButton.trigger('click');
                    return false;
                }
            });
    }

    // Update the live chat status classes and adjust the markup and events
    function updateChatStatus() {
        if (showBadge) $body.addClass('livechat-showbadge');

        updateButtonOnlineState();

        if (showBadge) {
            badgePosition();
            $win.off('dk:widthChanged.chatbadge').on('dk:widthChanged.chatbadge', function(_, {layoutChanged, isMobile}) {
                if (layoutChanged) {
                    if (isMobile) {
                        $('.livechat-floating .livechat-badge').css({'display': 'block', 'position': 'fixed', 'left': '', 'right': ''});
                        $win.off('scroll.chatbadge');
                    } else {
                        badgePosition();
                        $win.on('scroll.chatbadge', function () { badgePosition(); });
                    }
                } else if (!isMobile) {
                    badgePosition();
                }
            });
        } else {
            $('.livechat-floating').remove();
            noBadge = true;
        }
    }

    // Determine if ChatBeacon has loaded, and if not, watch for the button to be added to the DOM
    if ((cbButtonOuter = doc.getElementById(cbButtonId))) {
        onChatBeaconLoaded();
    } else {
        const MO = win.MutationObserver || win.WebKitMutationObserver;
        if (MO) {
            let observer = new MO(mutations => {
                mutations.forEach(mutation => {
                    let nodes = Array.prototype.slice.call(mutation.addedNodes);
                    const button = nodes.filter(node => node.id === cbButtonId)[0];
                    if (button) {
                        if (observer) observer.disconnect();
                        observer = null;
                        cbButtonOuter = button;
                        onChatBeaconLoaded();
                    }
                });
            });
            observer.observe(doc.body, { childList: true });
        }
    }

    if (statusUrl) {
        // Only set up live chat if the chat status URL is available
        $.ajax({
            url: statusUrl,
            success: function(data) {
                isOnline = (data.online || data['Online']) ? true : false;
                showBadge = (data.badge || data.badgeEnabled || data['Badge'] || data['BadgeEnabled']) ? true : false;
                updateChatStatus();
            },
            error: function() {
                updateChatStatus();
            }
        });
    } else {
        $('.livechat-floating').remove();
        noBadge = true;
    }

    // On document loaded
    $(function () {
        const $footerChatIcon = $('.livechat-source .livechat-badge').first();
        if (!noBadge && !$floating.length && $footerChatIcon.length) {
            // The floating badge is not on the page; clone it from the .livechat-source
            $floating = $('<div class="livechat-floating"></div>');
            $badge = $footerChatIcon.clone().removeAttr('style');
            // Fix SVG gradient IDs to avoid duplication on the page
            $badge.find('linearGradient[id]').each(function () {
                const $grad = $(this), origId = $grad.attr('id'), newId = win.dk.generateId('svg');
                $grad.attr('id', newId);
                $badge.find('[fill]').each(function () {
                    const $elt = $(this), fill = $elt.attr('fill') || '';
                    if (fill.startsWith('url(#') && fill.indexOf(origId) >= 0) {
                        $elt.attr('fill', fill.replace(origId, newId));
                    }
                });
            });
            $('main').append($floating.append($badge));
            $buttons = $buttons.add($badge);
            badgePosition();
        }
    });
})(window, window.jQuery);
